<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="menuData != '' && user_role == 1 && loginUserPermission.indexOf('user_access') > -1">
            <div class="container-fluid xyz">
                <!--page content-->
                <div class="admin-page-content">
                    <div class="page-title-container">
                        <div class="page-name">{{pageTitle}}</div>
                    </div>
                    <!--Forms-->
                    <form>
                        <div class="forms-container">
                            <div class="row no-margin">

                                <div class="col-12 forms-block">

                                    <div class="common-form-field">
                                        <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                            <div class="form-label">Emp Id :</div>
                                        </div>
                                        <div v-if="edit_id == 0" class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                            <input v-on:blur="getDayforceData(true)" type="text" maxlength="190" class="form-control" v-model="emp_id" id="emp_id" placeholder="Enter Dayforce Id" name="emp_id" readonly>
                                            <!-- <span v-show="errors.has('emp_id')" class="help is-danger">{{ errors.first('emp_id') }}</span> -->
                                            <!-- v-validate="'required'" -->
                                            <div class="help is-danger">{{emp_error_msg}}</div>
                                            <div class="requiredstar">*</div>
                                        </div>
                                        <div v-else class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                            <span class="form-control">{{emp_id}}</span>
                                            <div class="help is-danger">{{emp_error_msg}}</div>
                                            <div class="requiredstar">*</div>
                                        </div>
                                    </div>

                                    <div class="common-form-field">
                                        <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                            <div class="form-label">User Name :</div>
                                        </div>
                                        <div  v-if="!isDisabled" class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                            <template v-if="isNewDayforaceId">
                                                <input v-on:blur="getDayforceData(false)" type="text" maxlength="190" class="form-control" v-model="username" id="username" placeholder="Enter User Name" name="username" readonly>
                                            </template>
                                            <template v-else>
                                                <input type="text" maxlength="190" class="form-control" v-model="username" id="username" placeholder="Enter User Name" name="username" readonly>
                                            </template>
                                            <!-- <span v-show="errors.has('username')" class="help is-danger">{{ errors.first('username') }}</span> -->
                                            <div class="help is-danger">{{username_error_msg}}</div>
                                            <div class="requiredstar">*</div>
                                        </div>
                                        <div v-else class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                            <span class="form-control">{{username}}</span>
                                            <div class="help is-danger">{{username_error_msg}}</div>
                                            <div class="requiredstar">*</div>
                                        </div>
                                    </div>

                                    <!-- <div class="common-form-field">
                                        <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                            <div class="form-label">Email :</div>
                                        </div>
                                        <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                            <input type="text" maxlength="190" class="form-control" v-model="email" id="email" placeholder="Enter Email" name="email">
                                            <div class="help is-danger">{{email_error_msg}}</div>
                                            <div class="requiredstar">*</div>
                                        </div>
                                    </div> -->

                                    <div class="common-form-field">
                                        <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                            <div class="form-label">First Name :</div>
                                        </div>
                                        <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                            <input type="text" maxlength="190" class="form-control" v-model="first_name" id="first_name" placeholder="Enter First Name" name="first_name" readonly>
                                            <!-- <span v-show="errors.has('first_name')" class="help is-danger">{{ errors.first('first_name') }}</span> -->
                                            <div class="help is-danger">{{first_name_error_msg}}</div>
                                            <div class="requiredstar">*</div>
                                        </div>
                                    </div>
                                    
                                    <div class="common-form-field">
                                        <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                            <div class="form-label">Last Name :</div>
                                        </div>
                                        <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                            <input type="text" maxlength="190" class="form-control" v-model="last_name" id="last_name" placeholder="Enter Last Name" name="last_name" readonly>
                                            <!-- <span v-show="errors.has('last_name')" class="help is-danger">{{ errors.first('last_name') }}</span> -->
                                            <!-- v-validate="'required'" -->
                                            <div class="help is-danger">{{last_name_error_msg}}</div>
                                            <div class="requiredstar">*</div>
                                        </div>
                                    </div>
                                    <div class="common-form-field">
                                        <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                            <div class="form-label">Location :</div>
                                        </div>
                                        <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                            <v-select v-model="locationId" name="locationId" placeholder="Select Location."
                                                label="text"
                                                :options="locationArr" :clearable=false>
                                            </v-select>
                                            <div class="help is-danger">{{location_error_msg}}</div>
                                            <div class="requiredstar">*</div>
                                        </div>
                                    </div>
                                    <div class="common-form-field">
                                        <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                            <div class="form-label">Role :</div>
                                        </div>
                                        <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-input-control paddingleft0">
                                            <v-select v-model="roleId" name="roleId" placeholder="Select Role."
                                                label="text"
                                                :options="roleArr" :clearable=false>
                                            </v-select>
                                            <div class="help is-danger">{{role_error_msg}}</div>
                                            <div class="requiredstar">*</div>
                                        </div>
                                    </div>

                                    <!--Permissions-->
                                    <div class="common-form-field">
                                        <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 form-title paddingleft0">
                                            <div class="form-label">Permissions :</div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <template v-for="(displayPer, index) in displayPermission">
                                                <label :key="'label ' + index">
                                                    <input :value="displayPer.id" :key="displayPer.id" v-model="checkedPermissionNames" type="checkbox" name="permission">
                                                    {{displayPer.description}}
                                                </label>
                                                <br :key="'br ' + index">
                                            </template>
                                        </div>
                                    </div>

                                    <div class="clearfix"></div>
                                    <!-- <div class="col-12 paddingleft0">
                                        <div class="form-label"><span>{{createdText}}</span> By: {{username}}</div>
                                    </div> -->

                                    <div class="mr-17 pb-2 float-l">
                                        <button type="button" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Cancel</span></button>
                                        <button v-if="edit_id == 0" type="submit" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="addUser('save_and_continue')"><span id="saveAndContinueAttachment">Save And Continue</span></button>
                                        <button type="submit" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="addUser('save')"><span id="createAttachment">Save</span></button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </form>
                    <!-- Forms -->
                </div>
                <!--page content-->
            </div>
        </template>
        <template v-else>
            <div class="admin-page-content">
                <div class="col-md-12 error-detail-main forms-container">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            We are Sorry!
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import Footer from "@/components/partials/Footer";
    import vSelect from 'vue-select';
    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';
    import {HTTP} from '../../http-common.js';
    import {commonMixins} from '../../mixins/commonMixins';
    import EventBus from "../../components/event-bus";
    var self;
    Vue.component("vueDropzone", vue2Dropzone);
    Vue.component('v-select', vSelect)
    Vue.component("app-footer", Footer);
    export default {
        name: 'UserAddForm',
        mixins: [commonMixins],
        data() {
            return {
                loginUserPermission: ['user_access'],
                //user_role: 0,
                pageTitle: 'Add User',
                createdText: 'Created',
                edit_id: 0,
                emp_id: '',
                username: "",
                email: "",
                first_name: "",
                last_name: "",
                locationId: "",
                locationArr: [],
                location_error_msg: "",
                roleId: "",
                roleArr: [],
                isDisabled: false,
                emp_error_msg: '',
                username_error_msg: '',
                email_error_msg: '',
                first_name_error_msg: '',
                last_name_error_msg: '',
                role_error_msg: '',
                displayPermission: [],
                checkedPermissions: [],
                checkedPermissionNames:[],
                chkDayforceId:false,
                isNewDayforaceId: false,
            }
        },
        watch: {
            /* username: function (username) {
                if(username && username != '') {
                    self.email = username;
                }
            }, */
            emp_id: function (emp_id) {
                if(emp_id.length > 2) {
                    self.getDayforceData(true);
                }
            }
        },
        beforeMount: function () {
            self = this;
        },
        created: function () {
        },
        mounted: function () {
            self.menuslug = "user-access";
            var userObj = localStorage.getItem('user_obj');
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                // self.username = self.formatString(userJson["first_name"] + " " + userJson["last_name"]);
            }
            self.loadRole();
            self.loadLocation();
            self.showLoader();
            var path = window.location.pathname;
            var segments = path.split("/");

            this.$nextTick(function () {
                if (segments[1] == 'updateuser') {
                    if (segments[2]) {
                        self.edit_id = segments[2];
                        self.pageTitle = 'Edit User';
                        self.loadUser();
                        $("#addAndContinueLocationBtn").hide();
                        $("#createAttachment").html("Update");
                    }
                } else {
                    self.hideLoader();
                }
            });
            self.getRole();
            self.getAllPermission();
        },
        methods: {
            buttonBack() {
                self.$router.push('/user/list');
            },
            loadRole() {                
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };
                self.showLoader();
                HTTP.get("getrole", config)
                        .then(function (response) {
                            self.roleArr = [];
                            $.each(response.data.content, function (i) {
                                if (response.data.content[i].value != 0) {
                                    self.roleArr.push(response.data.content[i]);
                                }
                            });
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            self.catchHandler(err, function () {});
                        });
            },
            loadLocation() {                
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };
                self.showLoader();
                HTTP.get("getlocation", config)
                        .then(function (response) {
                            self.locationArr = response.data.content;
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            self.catchHandler(err, function () {});
                        });
            },
            getAllPermission() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                    /* params: {
                        'emp_id': self.emp_id
                    } */
                };
                self.showLoader();
                HTTP.get("getallpermission", config)
                    .then(function (response) {
                        if (response.data.code == 200 && response.data.status == 'success') {
                            self.displayPermission = response.data.content;
                        }
                        self.hideLoader();
                    })
                    .catch(function (error) {
                        
                        self.catchHandler(error, function () {});
                    })
            },
            getDayforceData(isDayforceId) {

                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                    params: {
                        'userDetail': isDayforceId ? self.emp_id : self.username,
                    }
                };
                // self.showLoader();
            //     HTTP.get("getuserdatabydayforceid", config)
            //         .then(function (response) {
            //             if (response.data.code == 200 && response.data.status == 'success') {
                            
            //                 if(response.data.content.first_name == null || response.data.content.first_name == null) {
            //                     var name = response.data.content.name.split(" ");
            //                     self.first_name = name[0];
            //                     self.last_name = name[1];
            //                 } else {
            //                     self.first_name = response.data.content.first_name;
            //                     self.last_name = response.data.content.last_name;
            //                 }
            //                 self.email = response.data.content.username;
            //                 self.username = response.data.content.username;
            //                 self.isDisabled = true;
            //                 self.chkDayforceId = true;
                            
            //                 setTimeout(function () {
            //                     if(!isDayforceId) {
            //                         var message = "This email is already linked with another Dayforce ID, Please enter unique email address.";
            //                         var type = 'info';
            //                         self.$swal.fire(message, 'Email already linked', type);
            //                         self.username = "";
            //                         self.isDisabled = false;
            //                     }
            //                 }, 100);
            //                 self.isNewDayforaceId = false;
            //             } else {
            //                 /* self.isDisabled = false;
            //                 self.first_name = "";
            //                 self.last_name = "";
            //                 self.username = "";
            //                 self.email = "";
            //                 self.chkDayforceId = false;
            //                 self.isNewDayforaceId = true; */
            //             }
            //             // self.hideLoader();
            //         })
            //         .catch(function (error) {
            //             self.isNewDayforaceId = true;
            //             self.isDisabled = false;
            //             self.first_name = "";
            //             self.last_name = "";
            //             self.username = "";
            //             self.email = "";
            //             // self.hideLoader();
            //             self.chkDayforceId = false;
            //             // error.response.data.message = "Please Contact HR!";
            //             // self.catchHandler(error, function () {});
            //         })
            },
            loadUser() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                    params: {
                        id: segments[2]
                    }
                };
                self.showLoader();
                HTTP.get("getUserById", config)
                        .then(function (response) {
                            self.emp_id = (response.data.content.emp_id == null) ? '' : response.data.content.emp_id;
                            self.username = response.data.content.username;
                            self.email = response.data.content.email;
                            self.first_name = response.data.content.first_name;
                            self.last_name = response.data.content.last_name;
                            self.locationId = {text: response.data.content.location_name, value:response.data.content.location_id}
                            self.roleId = {text: response.data.roles.name, value:response.data.roles.id}
                            var tempCheckedPermissionNames = [];
                            if(response.data.permissions && response.data.permissions.length > 0) {
                                for(var i=0; i<response.data.permissions.length; i++) {
                                    tempCheckedPermissionNames.push(response.data.permissions[i].id);
                                }
                            }
                            self.checkedPermissionNames = [];
                            self.checkedPermissionNames = [...new Set(tempCheckedPermissionNames)];
                            // console.log(self.checkedPermissionNames);
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            self.catchHandler(err, function () {});
                        });
            },
            addUser(flag) {

                // console.log(self.checkedPermissionNames);return;
                // if(self.chkDayforceId) {

                    self.emp_error_msg = "";
                    self.username_error_msg = "";
                    self.first_name_error_msg = "";
                    self.last_name_error_msg = "";
                    self.email_error_msg = "";
                    self.location_error_msg = "";
                    self.role_error_msg = "";

                    if((self.emp_id == '' || self.emp_id == null) && self.edit_id != 0) {
                        self.emp_error_msg = "The Dayforce Id field is required.";
                    } else {
                        var error = true;
                        if(self.emp_id == '' || self.emp_id == null) {
                            error = false;
                            self.emp_error_msg = "The Dayforce Id field is required.";
                        }
                        if(self.username == '' || self.username == null) {
                            error = false;
                            self.username_error_msg = "The Username field is required.";
                        }                        
                        if(self.username && !self.validEmail(self.username)) {
                            error = false;
                            self.username_error_msg = "Username Must Be In Proper Email Format.";
                        }
                        // if(self.email == '' || self.email == null) {
                        //     error = false;
                        //     self.email_error_msg = "The Email field is required.";
                        // }
                        if(self.first_name == '' || self.first_name == null) {
                            error = false;
                            self.first_name_error_msg = "The First Name field is required.";
                        }
                        if(self.last_name == '' || self.last_name == null) {
                            error = false;
                            self.last_name_error_msg = "The Last Name field is required.";
                        }
                        if(self.email && !self.validEmail(self.email)) {
                            self.email_error_msg = "Email Must Be In Proper Email Format.";
                            error = false;
                        }
                        if(self.locationId == null || !self.locationId.value) {
                            self.location_error_msg = "Select Location.";
                            error = false;
                        }
                        if(self.roleId == null || !self.roleId.value) {
                            self.role_error_msg = "Select Role.";
                            error = false;
                        }

                        if(error) {
                            var path = window.location.pathname;
                            var segments = path.split("/");
                            var config = {
                                headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                            };

                            var fields = {
                                emp_id: self.emp_id,
                                username: self.username,
                                email: self.email,
                                first_name: self.first_name,
                                last_name: self.last_name,
                                id: self.edit_id,
                                locationId: self.locationId.value, 
                                roleId: self.roleId.value, 
                                permission: self.checkedPermissionNames
                            };
                            self.showLoader();
                            HTTP.post("addupdateuser", fields, config)
                                .then(function (response) {
                                    if (response.data.status == "success") {
                                        /* if(self.checkedPermissionNames && self.checkedPermissionNames.length > 0 ) {
                                            var tempArray = [];
                                            for(var i=0;i<self.checkedPermissionNames.length;i++) {
                                                if(self.checkedPermissionNames[i] == 1) {
                                                    tempArray.push('user_access');
                                                }
                                                if(self.checkedPermissionNames[i] == 2) {
                                                    tempArray.push('qr_code_scan_list');
                                                }
                                            }
                                            EventBus.$emit('sidebarPermission', tempArray);
                                        } */
                                        

                                        if (flag == 'save') {
                                            self.buttonBack();
                                        } else {
                                            self.emp_id = '';
                                            self.username = '';
                                            self.email = '';
                                            self.first_name = '';
                                            self.last_name = '';
                                            self.locationId = "";
                                            self.roleId = "";
                                            self.checkedPermissionNames = [];
                                        }
                                    }

                                    
                                    self.hideLoader();
                                })
                                .catch(function (err) {
                                    self.hideLoader();
                                    self.catchHandler(err, function () {});
                                });
                        }
                            
                    }
                /* } else {
                    var message = "Please Contact HR!";
                    var type = 'error';
                    this.$swal.fire(message, 'Invalid Dayforace Id', type);
                } */
            },
            formatString: function (data) {
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            validEmail: function(email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
        }
    };
    EventBus.$on('roleAndPermissions', function (isLogin, id, name, system_year, loginUserPermission) {
        if (typeof (self) != "undefined") {
            self.loginUserPermission = [];
            /* self.isShowLoggedinfields = isLogin;
            self.roleId = id;
            self.roleName = name;
            self.system_year = system_year; */
            self.loginUserPermission = loginUserPermission;
            console.log(self.loginUserPermission);
        }
    });
</script>


// WEBPACK FOOTER //
// src/components/UserManagement/AddUser.vue